import { Cushion, Rectangle } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import IconWithTheme from '../../icon-with-theme';

const FilterIconWrapper = ({ filterName, filterValue, onFilterClick, children }) => {
  const filterIsActive = filterValue && filterValue.length > 0;
  return (
    <Cushion horizontal="xsmall">
      <div style={{ position: 'relative', display: 'flex' }}>
        <Rectangle
          fill={filterValue ? 'primary' : '#d4d4d4'}
          radius="100%"
          onClick={() => onFilterClick(filterName)}
          style={{ cursor: 'pointer' }}
        >
          <Cushion all="xsmall">
            <IconWithTheme color={filterIsActive ? 'primaryContrast' : 'black'}>
              {children}
            </IconWithTheme>
          </Cushion>
        </Rectangle>
        {filterIsActive && (
          <div
            style={{
              position: 'absolute',
              top: '-5px',
              right: '0',
              width: '15px',
              height: '15px',
              borderRadius: '100%',
              backgroundColor: 'black',
              border: '1px solid white',
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '0.75rem',
            }}
          >
            1
          </div>
        )}
      </div>
    </Cushion>
  );
};

FilterIconWrapper.propTypes = {
  filterName: PropTypes.string.isRequired,
  filterValue: PropTypes.string,
  onFilterClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

FilterIconWrapper.defaultProps = {
  filterValue: '',
};

export default FilterIconWrapper;
